require('./accountIntervenerRemoveForm.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
//  @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY,
     CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const { ACCOUNT_INTERVENER_REMOVE_ID } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');

class AccountIntervenerRemoveForm extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick() {
        const { intervenerIndex, immAccount, removeIntervener } = this.props;

        removeIntervener(immAccount.get('accountId'), intervenerIndex);
    }

    render() {
        const { immIntervener, immAccount, immAccountIntervenerRemoval } = this.props;
        const title = formatText('accountInterveners-securityConfirmation');
        const inProgress = immAccountIntervenerRemoval.get('inProgress');
        const injectedStrings = [
            immIntervener.get('name'),
            immIntervener.get('type')
        ];
        const originAccount = API_ENTERPRISE_NUMBER.concat(
            API_CENTER,
            immAccount.get('product'),
            immAccount.get('contractNumber')
        );
        const operationParams = {
            originAccount
        };

        const exitLink = `/myprofile/accounts/${immAccount.get('accountId')}/details`;
        const operative = formatText('operatives-intervenerRemove');

        return (
            <OKSectionBox
                className="account-intervener-remove-form"
                title={title}
            >
                <section className="account-intervener-remove-form__content">
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={operative}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY}
                            extraClass="account-intervener-remove-form__confirm-script"
                        />
                    </ContactCenterRender>
                    <FormattedText
                        value="accountInterveners-removeMessage"
                        injectedStrings={injectedStrings}
                    />
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}/>
                    </ContactCenterRender>
                    <div className="account-intervener-remove-form__signature-passcode">
                        <SignaturePattern
                            operationType={ACCOUNT_INTERVENER_REMOVE_ID}
                            operationParams={operationParams}
                        />
                    </div>
                </section>

                <footer className="text-right account-intervener-remove-form__footer">
                    <div className="pull-left">
                        <OKLink
                            id="btnAccountIntervenersCancel"
                            to={exitLink}
                            modifier="inherit-styles"
                        >
                            <FormattedText value="accountInterveners-cancel" />
                        </OKLink>
                    </div>
                    <SignaturePatternButton id="btnAccountIntervenersRemove" loading={inProgress} onClick={this.handleOnClick} >
                        <FormattedText value="accountInterveners-remove" />
                    </SignaturePatternButton>
                </footer>
            </OKSectionBox>
        );
    }
}

AccountIntervenerRemoveForm.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immAccountIntervenerRemoval: PropTypes.object.isRequired,
    intervenerIndex: PropTypes.string.isRequired,
    immIntervener: PropTypes.object,
    removeIntervener: PropTypes.func.isRequired
};

module.exports = AccountIntervenerRemoveForm;
